import PropTypes from 'prop-types';
import React from 'react';
import Layout from '../../components/Layout/Layout';
import PageSection from '../../components/Layout/PageSection/PageSection';
import CompanyCard from '../../components/Partners/CompanyCard/CompanyCard';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
} from '../../components/Analytics/Snowplow/SnowplowPageViewTracker';

import './Partners.scss';

export default class Partners extends React.PureComponent {
    renderCompanies = () => {
        return this.props.partners.map((company) => (
            <CompanyCard {...company} />
        ));
    };

    render() {
        const header = <div className="page-Partners-header">Our Partners</div>;
        const subheader = (
            <div className="page-Partners-subheader">
                Fairygodboss enjoys working with partner organizations to help
                improve the workplace for women. Interested in collaborating
                with Fairygodboss? Please email{' '}
                <a href="mailto:partnerships@fairygodboss.com">
                    partnerships@fairygodboss.com
                </a>
            </div>
        );

        return (
            <div className="page-Partners">
                <SnowplowPageViewTracker
                    pageSection={PAGE_VIEW_SECTIONS.EMPLOYER_RESOURCES}
                    pageType={PAGE_VIEW_TYPES.LANDING_PAGE}
                />
                <Layout PAGE_PROPS={this.props.PAGE_PROPS}>
                    <PageSection className="main-page-section">
                        {header}
                        <div className="controlled-width-company">
                            {subheader}
                            <div className="company-display">
                                {this.props.partners &&
                                this.props.partners.length
                                    ? this.renderCompanies()
                                    : null}
                            </div>
                            <div className="clear" />
                        </div>
                    </PageSection>
                </Layout>
            </div>
        );
    }
}

Partners.propTypes = {
    /**
     * partners information
     */
    partners: PropTypes.arrayOf(
        PropTypes.shape({
            /**
             * logo information
             */
            logo: PropTypes.shape({
                src: PropTypes.string,
                alt: PropTypes.string,
            }),
            /**
             * url
             */
            url: PropTypes.string,
            /**
             * id
             */
            partnerId: PropTypes.number,
            /**
             * name
             */
            partnerName: PropTypes.string,
        })
    ).isRequired,
    PAGE_PROPS: PropTypes.shape().isRequired,
};
